import '../lib/typedef';
import client from '../lib/http-client';

const endpoint = '/storefront';

export default {
	getUniqueCode(cb, errorCb) {
		const url = `${endpoint}/unique_code`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
